import Reflux from 'reflux';

import accessoryStore from './accessory-store';
import itemStore from './item-store';
import actions from '../actions';

export default Reflux.createStore({
	listenables: actions,

	init() {
		this.listenTo(accessoryStore, this.onItemChange);
		this.listenTo(itemStore, this.onItemChange);
		this.state = {
			item: null,
			isAuto: false // auto popup if item is available
		};
	},

	onShowSheet(item) {
		if (item !== this.state.item) {
			this.state.item = item;
			this.state.isAuto = false;
			if (item === null) {
				actions.resetSheet();
			}
			this.output();
		}
	},

	onCloseSheet() {
		this.state.item = null;
		this.output();
	},

	onItemChange(item) {
		if (item.sheet !== null) {
			this.state.item = item.sheet;
			this.state.isAuto = true;
			this.output();
		}
	},

	getState() {
		return this.state;
	},

	output() {
		this.trigger(this.getState());
	},

	getInitialState() {
		return this.getState();
	}
});
